import React from 'react'

function Titlepage() {
  return (
    <div>
        <div  className="fille">
         <div className="container">
            <div className="row">
               <div className="col-md-12">
                  <div className="titlepage">
                     <h2>About Our Car Service </h2>
                  </div>
               </div>
            </div>
            <div classNameName="container">
               <div className="row">
                  <div className="col-md-10 offset-md-1">
                     <div className="about_img">
                        <div className="about_box">
                           <h3>What is included in a car service?</h3>
                           <p> As a car owner and driver, you are responsible not only for the condition and performance of your car but also for the welfare of your passengers, co-motorists on the road, as well as pedestrians nearby. This means that every time you drive your car, you should make sure that your vehicle is in top shape and will not cause any harm or accident to you or the people and vehicles around you.</p>
                           <a className="read_more">Read More</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </div>
  )
}

export default Titlepage